import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=6dd19f58&scoped=true&"
import script from "./confirm-dialog.vue?vue&type=script&lang=ts&"
export * from "./confirm-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-dialog.vue?vue&type=style&index=0&id=6dd19f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd19f58",
  null
  
)

export default component.exports